import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HeroPage from './HeroPage';
// import DemoPage from './DemoPage';
// import ContactPage from './ContactPage';
// import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CaseStudyDetail from './CaseStudyDetail';
import ScrollToTop from './ScrollToTop';

function App() {

  return (
    <Router>
      <ScrollToTop />
      <div className="relative flex flex-col min-h-screen">
        <Routes>
          <Route path="/" element={<HeroPage />} />
          {/* keep detail route */}
          <Route path="/demo/case-study/:id" element={<CaseStudyDetail />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
